import request from '@/utils/request'

export function getFileList(params) {
  return request({
    url: '/admin/file/list',
    method: 'get',
    params
  })
}

export function scanFileReferences() {
  return request({
    url: '/admin/file/scan',
    method: 'post'
  })
}

export function deleteFile(id, force) {
  return request({
    url: '/admin/file/' + id,
    method: 'delete',
    params: { force: force || false }
  })
}

export function cleanOrphanFiles() {
  return request({
    url: '/admin/file/clean-orphan',
    method: 'post'
  })
}
